// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMCA3Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNCA0LjU4NkwxLjcwNyAyLjI5M0ExIDEgMCAxMC4yOTMgMy43MDdsMyAzYS45OTcuOTk3IDAgMDAxLjQxNCAwbDUtNUExIDEgMCAxMDguMjkzLjI5M0w0IDQuNTg2eiIvPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.m_dd3f7539 {
  position: relative;
  border: calc(0.0625rem * var(--mantine-scale)) solid;
  border-radius: var(--mantine-radius-default);
}

  :where([data-mantine-color-scheme='light']) .m_dd3f7539 {
    border-color: var(--mantine-color-gray-4);
}

  :where([data-mantine-color-scheme='dark']) .m_dd3f7539 {
    border-color: var(--mantine-color-dark-4);
}

.m_d37966d9 {
  padding: 0;
  margin: 0;
}

.m_d37966d9 li > p {
    margin: 0;
  }

.m_d37966d9 ul li,
  .m_d37966d9 ol li {
    margin-top: calc(0.125rem * var(--mantine-scale));
  }

.m_d37966d9 p {
    margin-bottom: calc(0.4375rem * var(--mantine-scale));
  }

.m_d37966d9 h1,
  .m_d37966d9 h2,
  .m_d37966d9 h3,
  .m_d37966d9 h4,
  .m_d37966d9 h5,
  .m_d37966d9 h6,
  .m_d37966d9 p {
    margin-top: 0;
  }

.m_c2204cc2 {
  background-color: var(--mantine-color-body);
  border-radius: var(--mantine-radius-default);
}

.m_c2204cc2 .ProseMirror {
    outline: 0;
    padding: var(--mantine-spacing-md);
  }

.m_c2204cc2 .ProseMirror > *:last-child {
    margin-bottom: 0;
  }

.m_c2204cc2 .ProseMirror p.is-editor-empty:first-of-type::before {
    content: attr(data-placeholder);
    pointer-events: none;
    user-select: none;
    float: left;
    height: 0;
    color: var(--mantine-color-placeholder);
  }

.m_c2204cc2 pre {
    font-family: var(--mantine-font-family-monospace);
    border-radius: var(--mantine-radius-default);
    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);
  }

:where([data-mantine-color-scheme='light']) .m_c2204cc2 pre {
      background-color: var(--mantine-color-gray-0);
      color: var(--mantine-color-gray-9);
      --code-color-comment: var(--mantine-color-gray-5);
      --code-color-var: var(--mantine-color-red-7);
      --code-color-number: var(--mantine-color-blue-7);
      --code-color-title: var(--mantine-color-pink-7);
      --code-color-keyword: var(--mantine-color-violet-7);
}

:where([data-mantine-color-scheme='dark']) .m_c2204cc2 pre {
      background-color: var(--mantine-color-dark-8);
      color: var(--mantine-color-dark-1);
      --code-color-comment: var(--mantine-color-dark-2);
      --code-color-var: var(--mantine-color-red-5);
      --code-color-number: var(--mantine-color-cyan-5);
      --code-color-title: var(--mantine-color-yellow-5);
      --code-color-keyword: var(--mantine-color-violet-3);
}

.m_c2204cc2 pre code {
      background: none !important;
      color: inherit;
      font-size: var(--mantine-font-size-sm);
      padding: 0;
    }

.m_c2204cc2 pre .hljs-comment,
    .m_c2204cc2 pre .hljs-quote {
      color: var(--code-color-comment);
    }

.m_c2204cc2 pre .hljs-variable,
    .m_c2204cc2 pre .hljs-template-variable,
    .m_c2204cc2 pre .hljs-attribute,
    .m_c2204cc2 pre .hljs-tag,
    .m_c2204cc2 pre .hljs-regexp,
    .m_c2204cc2 pre .hljs-link,
    .m_c2204cc2 pre .hljs-name,
    .m_c2204cc2 pre .hljs-selector-id,
    .m_c2204cc2 pre .hljs-selector-class {
      color: var(--code-color-var);
    }

.m_c2204cc2 pre .hljs-number,
    .m_c2204cc2 pre .hljs-meta,
    .m_c2204cc2 pre .hljs-built_in,
    .m_c2204cc2 pre .hljs-builtin-name,
    .m_c2204cc2 pre .hljs-literal,
    .m_c2204cc2 pre .hljs-type,
    .m_c2204cc2 pre .hljs-params {
      color: var(--code-color-number);
    }

.m_c2204cc2 pre .hljs-string,
    .m_c2204cc2 pre .hljs-symbol,
    .m_c2204cc2 pre .hljs-bullet {
      color: var(--code-color-var);
    }

.m_c2204cc2 pre .hljs-title,
    .m_c2204cc2 pre .hljs-section {
      color: var(--code-color-title);
    }

.m_c2204cc2 pre .hljs-keyword,
    .m_c2204cc2 pre .hljs-selector-tag {
      color: var(--code-color-keyword);
    }

.m_c2204cc2 pre .hljs-emphasis {
      font-style: italic;
    }

.m_c2204cc2 pre .hljs-strong {
      font-weight: 700;
    }

.m_8a991b4f {
  background-color: var(--mantine-color-body);
}

.m_c2207da6 {
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--mantine-radius-default);
  cursor: default;
}

.m_c2207da6:where([data-variant='default']) {
    border: calc(0.0625rem * var(--mantine-scale)) solid;
    min-width: calc(1.625rem * var(--mantine-scale));
    height: calc(1.625rem * var(--mantine-scale));
  }

.m_c2207da6:where([data-variant='subtle']) {
    --control-icon-size: calc(1.25rem * var(--mantine-scale));
    min-width: calc(2rem * var(--mantine-scale));
    height: calc(2rem * var(--mantine-scale));
  }

:where([data-mantine-color-scheme='light']) .m_c2207da6 {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
    color: var(--mantine-color-gray-7);
}

:where([data-mantine-color-scheme='dark']) .m_c2207da6 {
    border-color: var(--mantine-color-dark-4);
    color: var(--mantine-color-dark-1);
}

:where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-variant='default']) {
      background-color: var(--mantine-color-dark-6);
    }

:where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-variant='subtle']) {
      background-color: var(--mantine-color-dark-7);
    }

.m_c2207da6:where([data-disabled]) {
    cursor: not-allowed;
  }

:where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-disabled]) {
      background-color: var(--mantine-color-gray-1);
      color: var(--mantine-color-gray-5);
}

:where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-disabled]) {
      background-color: var(--mantine-color-dark-5);
      color: var(--mantine-color-dark-3);
}

.m_c2207da6:where([data-interactive]:not([data-disabled])) {
    cursor: pointer;
  }

@media (hover: hover) {

  .m_c2207da6:where([data-interactive]:not([data-disabled])):hover {
      color: var(--mantine-color-bright);
  }
        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):hover:where([data-variant='default']) {
          background-color: var(--mantine-color-gray-0);
        }

        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):hover:where([data-variant='subtle']) {
          background-color: var(--mantine-color-gray-1);
        }

      :where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-interactive]:not([data-disabled])):hover {
        background-color: var(--mantine-color-dark-5);
  }
}

@media (hover: none) {

  .m_c2207da6:where([data-interactive]:not([data-disabled])):active {
      color: var(--mantine-color-bright);
  }
        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):active:where([data-variant='default']) {
          background-color: var(--mantine-color-gray-0);
        }

        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):active:where([data-variant='subtle']) {
          background-color: var(--mantine-color-gray-1);
        }

      :where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-interactive]:not([data-disabled])):active {
        background-color: var(--mantine-color-dark-5);
  }
}

.m_c2207da6:where([data-active]) {
    background-color: var(--mantine-primary-color-light);
    color: var(--mantine-primary-color-light-color);
  }

@media (hover: hover) {

  .m_c2207da6:where([data-active]):hover {
      background-color: var(--mantine-primary-color-light-hover);
  }
}

@media (hover: none) {

  .m_c2207da6:where([data-active]):active {
      background-color: var(--mantine-primary-color-light-hover);
  }
}

.m_9cdfeb3f {
  width: var(--control-icon-size, 16px);
  height: var(--control-icon-size, 16px);
}

.m_2ab47ef2 {
  display: flex;
  background-color: var(--mantine-color-body);
}

.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]) {
      border-radius: 0;
    }

.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]):where(:not(:last-of-type)) {
        border-inline-end-width: 0;
      }

.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]):where(:last-of-type) {
        border-start-end-radius: var(--mantine-radius-default);
        border-end-end-radius: var(--mantine-radius-default);
      }

.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]):where(:first-of-type) {
        border-start-start-radius: var(--mantine-radius-default);
        border-end-start-radius: var(--mantine-radius-default);
      }

.m_b67b711e {
  display: flex;
}

.m_296cf94c {
  border-start-end-radius: 0;
  border-end-end-radius: 0;
  border-inline-end: 0;
}

.m_cfef614 {
  border: calc(0.0625rem * var(--mantine-scale)) solid;
  color: var(--mantine-color-text);
  height: calc(1.5rem * var(--mantine-scale));
  width: calc(1.5rem * var(--mantine-scale));
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: var(--mantine-radius-default);
}

:where([data-mantine-color-scheme='light']) .m_cfef614 {
    background-color: var(--mantine-color-white);
    border-color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) .m_cfef614 {
    background-color: var(--mantine-color-dark-7);
    border-color: var(--mantine-color-dark-4);
}

.m_cfef614:where([data-active]) {
    background-color: var(--mantine-primary-color-light);
    color: var(--mantine-primary-color-filled);
  }

@media (hover: hover) {

  .m_cfef614:where([data-active]):hover {
      background-color: var(--mantine-primary-color-light-hover);
  }
}

@media (hover: none) {

  .m_cfef614:where([data-active]):active {
      background-color: var(--mantine-primary-color-light-hover);
  }
}

.m_3b28e7bb {
  border-start-start-radius: 0;
  border-end-start-radius: 0;
}

.m_4574a3c4 {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--mantine-spacing-sm);
  top: var(--rte-sticky-offset, 0px);
  background-color: var(--mantine-color-body);
  z-index: 1;
  border-start-end-radius: var(--mantine-radius-default);
  border-start-start-radius: var(--mantine-radius-default);
  border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;
}

.m_4574a3c4:where([data-variant='default']) {
    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);
  }

.m_4574a3c4:where([data-variant='subtle']) {
    padding: calc(0.25rem * var(--mantine-scale));
    row-gap: 0;
  }

:where([data-mantine-color-scheme='light']) .m_4574a3c4 {
    border-color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) .m_4574a3c4 {
    border-color: var(--mantine-color-dark-4);
}

.m_4574a3c4:where([data-sticky]) {
    position: sticky;
  }

.m_8b44009a {
  list-style-type: none;
  padding: 0;
  padding-inline-start: 0;
}

.m_8b44009a :where(li) {
    margin: 0;
    padding: 0;
    display: flex;
  }

.m_8b44009a :where(ul) {
    margin-top: calc(0.3125rem * var(--mantine-scale));
  }

.m_8b44009a p {
    margin: 0;
    padding: 0;
  }

.m_8b44009a :where(label) {
    display: inline-block;
  }

.m_8b44009a :where(input) {
    cursor: pointer;
    appearance: none;
    width: calc(1.125rem * var(--mantine-scale));
    height: calc(1.125rem * var(--mantine-scale));
    border: calc(0.0625rem * var(--mantine-scale)) solid;
    border-radius: var(--mantine-radius-default);
    vertical-align: middle;
    position: relative;
  }

:where([data-mantine-color-scheme='light']) .m_8b44009a :where(input) {
      background-color: var(--mantine-color-white);
      border-color: var(--mantine-color-gray-4);
}

:where([data-mantine-color-scheme='dark']) .m_8b44009a :where(input) {
      background-color: var(--mantine-color-dark-6);
      border-color: var(--mantine-color-dark-4);
}

.m_8b44009a :where(input):checked {
      background-color: var(--mantine-primary-color-filled);
      border-color: var(--mantine-primary-color-filled);
    }

.m_8b44009a :where(input):checked::before {
        position: absolute;
        content: '';
        inset: 0;
        background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
        background-repeat: no-repeat;
        background-size: calc(0.625rem * var(--mantine-scale));
        background-position: center;
      }

.m_8b44009a :where(li > label) {
    margin-inline-end: var(--mantine-spacing-sm);
  }
`, "",{"version":3,"sources":["webpack://./node_modules/@mantine/tiptap/styles.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,oDAAoD;EACpD,4CAA4C;AAC9C;;EAEE;IACE,yCAAyC;AAC7C;;EAEE;IACE,yCAAyC;AAC7C;;AAEA;EACE,UAAU;EACV,SAAS;AACX;;AAEA;IACI,SAAS;EACX;;AAEF;;IAEI,iDAAiD;EACnD;;AAEF;IACI,qDAAqD;EACvD;;AAEF;;;;;;;IAOI,aAAa;EACf;;AAEF;EACE,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;IACI,UAAU;IACV,kCAAkC;EACpC;;AAEF;IACI,gBAAgB;EAClB;;AAEF;IACI,+BAA+B;IAC/B,oBAAoB;IACpB,iBAAiB;IACjB,WAAW;IACX,SAAS;IACT,uCAAuC;EACzC;;AAEF;IACI,iDAAiD;IACjD,4CAA4C;IAC5C,4DAA4D;EAC9D;;AAEF;MACM,6CAA6C;MAC7C,kCAAkC;MAClC,iDAAiD;MACjD,4CAA4C;MAC5C,gDAAgD;MAChD,+CAA+C;MAC/C,mDAAmD;AACzD;;AAEA;MACM,6CAA6C;MAC7C,kCAAkC;MAClC,iDAAiD;MACjD,4CAA4C;MAC5C,gDAAgD;MAChD,iDAAiD;MACjD,mDAAmD;AACzD;;AAEA;MACM,2BAA2B;MAC3B,cAAc;MACd,sCAAsC;MACtC,UAAU;IACZ;;AAEJ;;MAEM,gCAAgC;IAClC;;AAEJ;;;;;;;;;MASM,4BAA4B;IAC9B;;AAEJ;;;;;;;MAOM,+BAA+B;IACjC;;AAEJ;;;MAGM,4BAA4B;IAC9B;;AAEJ;;MAEM,8BAA8B;IAChC;;AAEJ;;MAEM,gCAAgC;IAClC;;AAEJ;MACM,kBAAkB;IACpB;;AAEJ;MACM,gBAAgB;IAClB;;AAEJ;EACE,2CAA2C;AAC7C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;IACI,oDAAoD;IACpD,gDAAgD;IAChD,6CAA6C;EAC/C;;AAEF;IACI,yDAAyD;IACzD,4CAA4C;IAC5C,yCAAyC;EAC3C;;AAEF;IACI,4CAA4C;IAC5C,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;IACI,yCAAyC;IACzC,kCAAkC;AACtC;;AAEA;MACM,6CAA6C;IAC/C;;AAEJ;MACM,6CAA6C;IAC/C;;AAEJ;IACI,mBAAmB;EACrB;;AAEF;MACM,6CAA6C;MAC7C,kCAAkC;AACxC;;AAEA;MACM,6CAA6C;MAC7C,kCAAkC;AACxC;;AAEA;IACI,eAAe;EACjB;;AAEF;;EAEE;MACI,kCAAkC;EACtC;QACM;UACE,6CAA6C;QAC/C;;QAEA;UACE,6CAA6C;QAC/C;;MAEF;QACE,6CAA6C;EACnD;AACF;;AAEA;;EAEE;MACI,kCAAkC;EACtC;QACM;UACE,6CAA6C;QAC/C;;QAEA;UACE,6CAA6C;QAC/C;;MAEF;QACE,6CAA6C;EACnD;AACF;;AAEA;IACI,oDAAoD;IACpD,+CAA+C;EACjD;;AAEF;;EAEE;MACI,0DAA0D;EAC9D;AACF;;AAEA;;EAEE;MACI,0DAA0D;EAC9D;AACF;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,2CAA2C;AAC7C;;AAEA;MACM,gBAAgB;IAClB;;AAEJ;QACQ,0BAA0B;MAC5B;;AAEN;QACQ,sDAAsD;QACtD,oDAAoD;MACtD;;AAEN;QACQ,wDAAwD;QACxD,sDAAsD;MACxD;;AAEN;EACE,aAAa;AACf;;AAEA;EACE,0BAA0B;EAC1B,wBAAwB;EACxB,oBAAoB;AACtB;;AAEA;EACE,oDAAoD;EACpD,gCAAgC;EAChC,2CAA2C;EAC3C,0CAA0C;EAC1C,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;IACI,4CAA4C;IAC5C,yCAAyC;AAC7C;;AAEA;IACI,6CAA6C;IAC7C,yCAAyC;AAC7C;;AAEA;IACI,oDAAoD;IACpD,0CAA0C;EAC5C;;AAEF;;EAEE;MACI,0DAA0D;EAC9D;AACF;;AAEA;;EAEE;MACI,0DAA0D;EAC9D;AACF;;AAEA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,8BAA8B;EAC9B,kCAAkC;EAClC,2CAA2C;EAC3C,UAAU;EACV,sDAAsD;EACtD,wDAAwD;EACxD,2DAA2D;AAC7D;;AAEA;IACI,4DAA4D;EAC9D;;AAEF;IACI,6CAA6C;IAC7C,UAAU;EACZ;;AAEF;IACI,yCAAyC;AAC7C;;AAEA;IACI,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;EAClB;;AAEF;EACE,qBAAqB;EACrB,UAAU;EACV,uBAAuB;AACzB;;AAEA;IACI,SAAS;IACT,UAAU;IACV,aAAa;EACf;;AAEF;IACI,kDAAkD;EACpD;;AAEF;IACI,SAAS;IACT,UAAU;EACZ;;AAEF;IACI,qBAAqB;EACvB;;AAEF;IACI,eAAe;IACf,gBAAgB;IAChB,4CAA4C;IAC5C,6CAA6C;IAC7C,oDAAoD;IACpD,4CAA4C;IAC5C,sBAAsB;IACtB,kBAAkB;EACpB;;AAEF;MACM,4CAA4C;MAC5C,yCAAyC;AAC/C;;AAEA;MACM,6CAA6C;MAC7C,yCAAyC;AAC/C;;AAEA;MACM,qDAAqD;MACrD,iDAAiD;IACnD;;AAEJ;QACQ,kBAAkB;QAClB,WAAW;QACX,QAAQ;QACR,yDAA2T;QAC3T,4BAA4B;QAC5B,sDAAsD;QACtD,2BAA2B;MAC7B;;AAEN;IACI,4CAA4C;EAC9C","sourcesContent":[".m_dd3f7539 {\n  position: relative;\n  border: calc(0.0625rem * var(--mantine-scale)) solid;\n  border-radius: var(--mantine-radius-default);\n}\n\n  :where([data-mantine-color-scheme='light']) .m_dd3f7539 {\n    border-color: var(--mantine-color-gray-4);\n}\n\n  :where([data-mantine-color-scheme='dark']) .m_dd3f7539 {\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_d37966d9 {\n  padding: 0;\n  margin: 0;\n}\n\n.m_d37966d9 li > p {\n    margin: 0;\n  }\n\n.m_d37966d9 ul li,\n  .m_d37966d9 ol li {\n    margin-top: calc(0.125rem * var(--mantine-scale));\n  }\n\n.m_d37966d9 p {\n    margin-bottom: calc(0.4375rem * var(--mantine-scale));\n  }\n\n.m_d37966d9 h1,\n  .m_d37966d9 h2,\n  .m_d37966d9 h3,\n  .m_d37966d9 h4,\n  .m_d37966d9 h5,\n  .m_d37966d9 h6,\n  .m_d37966d9 p {\n    margin-top: 0;\n  }\n\n.m_c2204cc2 {\n  background-color: var(--mantine-color-body);\n  border-radius: var(--mantine-radius-default);\n}\n\n.m_c2204cc2 .ProseMirror {\n    outline: 0;\n    padding: var(--mantine-spacing-md);\n  }\n\n.m_c2204cc2 .ProseMirror > *:last-child {\n    margin-bottom: 0;\n  }\n\n.m_c2204cc2 .ProseMirror p.is-editor-empty:first-of-type::before {\n    content: attr(data-placeholder);\n    pointer-events: none;\n    user-select: none;\n    float: left;\n    height: 0;\n    color: var(--mantine-color-placeholder);\n  }\n\n.m_c2204cc2 pre {\n    font-family: var(--mantine-font-family-monospace);\n    border-radius: var(--mantine-radius-default);\n    padding: var(--mantine-spacing-sm) var(--mantine-spacing-md);\n  }\n\n:where([data-mantine-color-scheme='light']) .m_c2204cc2 pre {\n      background-color: var(--mantine-color-gray-0);\n      color: var(--mantine-color-gray-9);\n      --code-color-comment: var(--mantine-color-gray-5);\n      --code-color-var: var(--mantine-color-red-7);\n      --code-color-number: var(--mantine-color-blue-7);\n      --code-color-title: var(--mantine-color-pink-7);\n      --code-color-keyword: var(--mantine-color-violet-7);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_c2204cc2 pre {\n      background-color: var(--mantine-color-dark-8);\n      color: var(--mantine-color-dark-1);\n      --code-color-comment: var(--mantine-color-dark-2);\n      --code-color-var: var(--mantine-color-red-5);\n      --code-color-number: var(--mantine-color-cyan-5);\n      --code-color-title: var(--mantine-color-yellow-5);\n      --code-color-keyword: var(--mantine-color-violet-3);\n}\n\n.m_c2204cc2 pre code {\n      background: none !important;\n      color: inherit;\n      font-size: var(--mantine-font-size-sm);\n      padding: 0;\n    }\n\n.m_c2204cc2 pre .hljs-comment,\n    .m_c2204cc2 pre .hljs-quote {\n      color: var(--code-color-comment);\n    }\n\n.m_c2204cc2 pre .hljs-variable,\n    .m_c2204cc2 pre .hljs-template-variable,\n    .m_c2204cc2 pre .hljs-attribute,\n    .m_c2204cc2 pre .hljs-tag,\n    .m_c2204cc2 pre .hljs-regexp,\n    .m_c2204cc2 pre .hljs-link,\n    .m_c2204cc2 pre .hljs-name,\n    .m_c2204cc2 pre .hljs-selector-id,\n    .m_c2204cc2 pre .hljs-selector-class {\n      color: var(--code-color-var);\n    }\n\n.m_c2204cc2 pre .hljs-number,\n    .m_c2204cc2 pre .hljs-meta,\n    .m_c2204cc2 pre .hljs-built_in,\n    .m_c2204cc2 pre .hljs-builtin-name,\n    .m_c2204cc2 pre .hljs-literal,\n    .m_c2204cc2 pre .hljs-type,\n    .m_c2204cc2 pre .hljs-params {\n      color: var(--code-color-number);\n    }\n\n.m_c2204cc2 pre .hljs-string,\n    .m_c2204cc2 pre .hljs-symbol,\n    .m_c2204cc2 pre .hljs-bullet {\n      color: var(--code-color-var);\n    }\n\n.m_c2204cc2 pre .hljs-title,\n    .m_c2204cc2 pre .hljs-section {\n      color: var(--code-color-title);\n    }\n\n.m_c2204cc2 pre .hljs-keyword,\n    .m_c2204cc2 pre .hljs-selector-tag {\n      color: var(--code-color-keyword);\n    }\n\n.m_c2204cc2 pre .hljs-emphasis {\n      font-style: italic;\n    }\n\n.m_c2204cc2 pre .hljs-strong {\n      font-weight: 700;\n    }\n\n.m_8a991b4f {\n  background-color: var(--mantine-color-body);\n}\n\n.m_c2207da6 {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: var(--mantine-radius-default);\n  cursor: default;\n}\n\n.m_c2207da6:where([data-variant='default']) {\n    border: calc(0.0625rem * var(--mantine-scale)) solid;\n    min-width: calc(1.625rem * var(--mantine-scale));\n    height: calc(1.625rem * var(--mantine-scale));\n  }\n\n.m_c2207da6:where([data-variant='subtle']) {\n    --control-icon-size: calc(1.25rem * var(--mantine-scale));\n    min-width: calc(2rem * var(--mantine-scale));\n    height: calc(2rem * var(--mantine-scale));\n  }\n\n:where([data-mantine-color-scheme='light']) .m_c2207da6 {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n    color: var(--mantine-color-gray-7);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_c2207da6 {\n    border-color: var(--mantine-color-dark-4);\n    color: var(--mantine-color-dark-1);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-variant='default']) {\n      background-color: var(--mantine-color-dark-6);\n    }\n\n:where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-variant='subtle']) {\n      background-color: var(--mantine-color-dark-7);\n    }\n\n.m_c2207da6:where([data-disabled]) {\n    cursor: not-allowed;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-disabled]) {\n      background-color: var(--mantine-color-gray-1);\n      color: var(--mantine-color-gray-5);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-disabled]) {\n      background-color: var(--mantine-color-dark-5);\n      color: var(--mantine-color-dark-3);\n}\n\n.m_c2207da6:where([data-interactive]:not([data-disabled])) {\n    cursor: pointer;\n  }\n\n@media (hover: hover) {\n\n  .m_c2207da6:where([data-interactive]:not([data-disabled])):hover {\n      color: var(--mantine-color-bright);\n  }\n        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):hover:where([data-variant='default']) {\n          background-color: var(--mantine-color-gray-0);\n        }\n\n        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):hover:where([data-variant='subtle']) {\n          background-color: var(--mantine-color-gray-1);\n        }\n\n      :where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-interactive]:not([data-disabled])):hover {\n        background-color: var(--mantine-color-dark-5);\n  }\n}\n\n@media (hover: none) {\n\n  .m_c2207da6:where([data-interactive]:not([data-disabled])):active {\n      color: var(--mantine-color-bright);\n  }\n        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):active:where([data-variant='default']) {\n          background-color: var(--mantine-color-gray-0);\n        }\n\n        :where([data-mantine-color-scheme='light']) .m_c2207da6:where([data-interactive]:not([data-disabled])):active:where([data-variant='subtle']) {\n          background-color: var(--mantine-color-gray-1);\n        }\n\n      :where([data-mantine-color-scheme='dark']) .m_c2207da6:where([data-interactive]:not([data-disabled])):active {\n        background-color: var(--mantine-color-dark-5);\n  }\n}\n\n.m_c2207da6:where([data-active]) {\n    background-color: var(--mantine-primary-color-light);\n    color: var(--mantine-primary-color-light-color);\n  }\n\n@media (hover: hover) {\n\n  .m_c2207da6:where([data-active]):hover {\n      background-color: var(--mantine-primary-color-light-hover);\n  }\n}\n\n@media (hover: none) {\n\n  .m_c2207da6:where([data-active]):active {\n      background-color: var(--mantine-primary-color-light-hover);\n  }\n}\n\n.m_9cdfeb3f {\n  width: var(--control-icon-size, 16px);\n  height: var(--control-icon-size, 16px);\n}\n\n.m_2ab47ef2 {\n  display: flex;\n  background-color: var(--mantine-color-body);\n}\n\n.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]) {\n      border-radius: 0;\n    }\n\n.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]):where(:not(:last-of-type)) {\n        border-inline-end-width: 0;\n      }\n\n.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]):where(:last-of-type) {\n        border-start-end-radius: var(--mantine-radius-default);\n        border-end-end-radius: var(--mantine-radius-default);\n      }\n\n.m_2ab47ef2:where([data-variant='default']) :where([data-rich-text-editor-control]):where(:first-of-type) {\n        border-start-start-radius: var(--mantine-radius-default);\n        border-end-start-radius: var(--mantine-radius-default);\n      }\n\n.m_b67b711e {\n  display: flex;\n}\n\n.m_296cf94c {\n  border-start-end-radius: 0;\n  border-end-end-radius: 0;\n  border-inline-end: 0;\n}\n\n.m_cfef614 {\n  border: calc(0.0625rem * var(--mantine-scale)) solid;\n  color: var(--mantine-color-text);\n  height: calc(1.5rem * var(--mantine-scale));\n  width: calc(1.5rem * var(--mantine-scale));\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: var(--mantine-radius-default);\n}\n\n:where([data-mantine-color-scheme='light']) .m_cfef614 {\n    background-color: var(--mantine-color-white);\n    border-color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_cfef614 {\n    background-color: var(--mantine-color-dark-7);\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_cfef614:where([data-active]) {\n    background-color: var(--mantine-primary-color-light);\n    color: var(--mantine-primary-color-filled);\n  }\n\n@media (hover: hover) {\n\n  .m_cfef614:where([data-active]):hover {\n      background-color: var(--mantine-primary-color-light-hover);\n  }\n}\n\n@media (hover: none) {\n\n  .m_cfef614:where([data-active]):active {\n      background-color: var(--mantine-primary-color-light-hover);\n  }\n}\n\n.m_3b28e7bb {\n  border-start-start-radius: 0;\n  border-end-start-radius: 0;\n}\n\n.m_4574a3c4 {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--mantine-spacing-sm);\n  top: var(--rte-sticky-offset, 0px);\n  background-color: var(--mantine-color-body);\n  z-index: 1;\n  border-start-end-radius: var(--mantine-radius-default);\n  border-start-start-radius: var(--mantine-radius-default);\n  border-bottom: calc(0.0625rem * var(--mantine-scale)) solid;\n}\n\n.m_4574a3c4:where([data-variant='default']) {\n    padding: var(--mantine-spacing-xs) var(--mantine-spacing-md);\n  }\n\n.m_4574a3c4:where([data-variant='subtle']) {\n    padding: calc(0.25rem * var(--mantine-scale));\n    row-gap: 0;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_4574a3c4 {\n    border-color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_4574a3c4 {\n    border-color: var(--mantine-color-dark-4);\n}\n\n.m_4574a3c4:where([data-sticky]) {\n    position: sticky;\n  }\n\n.m_8b44009a {\n  list-style-type: none;\n  padding: 0;\n  padding-inline-start: 0;\n}\n\n.m_8b44009a :where(li) {\n    margin: 0;\n    padding: 0;\n    display: flex;\n  }\n\n.m_8b44009a :where(ul) {\n    margin-top: calc(0.3125rem * var(--mantine-scale));\n  }\n\n.m_8b44009a p {\n    margin: 0;\n    padding: 0;\n  }\n\n.m_8b44009a :where(label) {\n    display: inline-block;\n  }\n\n.m_8b44009a :where(input) {\n    cursor: pointer;\n    appearance: none;\n    width: calc(1.125rem * var(--mantine-scale));\n    height: calc(1.125rem * var(--mantine-scale));\n    border: calc(0.0625rem * var(--mantine-scale)) solid;\n    border-radius: var(--mantine-radius-default);\n    vertical-align: middle;\n    position: relative;\n  }\n\n:where([data-mantine-color-scheme='light']) .m_8b44009a :where(input) {\n      background-color: var(--mantine-color-white);\n      border-color: var(--mantine-color-gray-4);\n}\n\n:where([data-mantine-color-scheme='dark']) .m_8b44009a :where(input) {\n      background-color: var(--mantine-color-dark-6);\n      border-color: var(--mantine-color-dark-4);\n}\n\n.m_8b44009a :where(input):checked {\n      background-color: var(--mantine-primary-color-filled);\n      border-color: var(--mantine-primary-color-filled);\n    }\n\n.m_8b44009a :where(input):checked::before {\n        position: absolute;\n        content: '';\n        inset: 0;\n        background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGZpbGw9Im5vbmUiIHZpZXdCb3g9IjAgMCAxMCA3Ij48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNCA0LjU4NkwxLjcwNyAyLjI5M0ExIDEgMCAxMC4yOTMgMy43MDdsMyAzYS45OTcuOTk3IDAgMDAxLjQxNCAwbDUtNUExIDEgMCAxMDguMjkzLjI5M0w0IDQuNTg2eiIvPjwvc3ZnPg==');\n        background-repeat: no-repeat;\n        background-size: calc(0.625rem * var(--mantine-scale));\n        background-position: center;\n      }\n\n.m_8b44009a :where(li > label) {\n    margin-inline-end: var(--mantine-spacing-sm);\n  }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
